import { jsx as m } from "react/jsx-runtime";
import { clsx as y } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { Children as g, isValidElement as i } from "react";
import { RocheUIBreadcrumbs as q } from "../breadcrumbs/roche-breadcrumbs.js";
import { RocheUIContainer as E } from "../container/roche-container.js";
import e from "./roche-grid.module.scss.js";
import { gridSlotNames as V, gridLayoutMap as j } from "./roche-grid.types.js";
const C = (o, c, p) => ({
  span: parseInt(o, 10),
  slotName: V[p.length][c]
}), G = (o) => o.split("-").map(C), M = (o) => o.split("-").reverse().map(C), k = (o) => o === "roche-staging-hero", S = (o) => o === "roche-story-staging-hero", z = (o) => o.type === q || o.type === "roche-breadcrumbs", D = (o) => o === "hero--variant-b", F = /* @__PURE__ */ new Set([
  "roche-stage-home",
  "roche-stage-home-teaser",
  "roche-stage-slider",
  "roche-staging-hero",
  "roche-story-staging-hero"
]), J = (o) => !!o && F.has(o), oo = ({
  layout: o,
  fullWidth: c,
  backgroundColor: p,
  hideInPrintView: B,
  isRightToLeft: _,
  noPadding: w,
  fullHeight: x,
  extendBackgroundToTop: u,
  stagingHero: d,
  multipleRows: I,
  overflowVisible: L,
  isComplementary: N,
  children: b
}) => {
  const l = j[o] || o, R = "columns is-centered is-variable is-0-mobile is-3-tablet is-4-desktop", a = g.toArray(b), A = a.some((s) => i(s) && z(s)), h = a.some(
    (s) => {
      var r, t;
      return i(s) && (k((r = s.props.blok) == null ? void 0 : r.component) || S((t = s.props.blok) == null ? void 0 : t.component));
    }
  ), v = a.some((s) => {
    var r;
    return i(s) && J((r = s.props.blok) == null ? void 0 : r.component);
  }), H = a.some(
    (s) => {
      var r, t, n, f;
      return i(s) && (k((r = s.props.blok) == null ? void 0 : r.component) || S((t = s.props.blok) == null ? void 0 : t.component)) && D(((n = s.props.blok) == null ? void 0 : n.variant) ?? ((f = s.props.blok) == null ? void 0 : f.layout)) || d;
    }
  ), T = (s) => {
    const r = s.split("-");
    return r.every((t) => t === r[0]);
  }, U = y(
    e.grid,
    u && e["grid--extend-background-to-top"],
    B && e["grid--hide-in-print-view"],
    (w || h) && e["grid--no-padding"],
    L && e["grid--overflow-visible"],
    A && e["grid--has-breadcrumbs"],
    (h || d) && e["grid--has-staging-hero"],
    v && e["grid--has-own-top-spacing"],
    H && e["grid--move-to-back"],
    T(l) && e["grid--equal-columns"]
  );
  if (!g)
    return null;
  const $ = _ ? M(l).reverse() : G(l);
  return /* @__PURE__ */ m(N ? "aside" : "div", { className: U, children: /* @__PURE__ */ m(
    E,
    {
      fullWidth: c,
      color: p,
      fullHeight: x,
      extendBackgroundToTop: u,
      extendBackgroundToBottom: !v,
      children: /* @__PURE__ */ m(
        "div",
        {
          className: `${y(
            e.grid__columns,
            R,
            I && e["grid__columns--multiple-rows"]
          )}`,
          children: $.map(({ span: s, slotName: r }, t) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
            /* @__PURE__ */ m("div", { className: `${e.grid__column} column is-${s} is-offset-0`, children: g.map(b, (n) => {
              if (i(n) && n.props.slot === r)
                return n;
            }) }, t)
          ))
        }
      )
    }
  ) });
};
export {
  oo as RocheUIGrid
};
